import { TrayType } from 'components/organisms/EditTrayModal/EditTrayModal.types'

/**
 * Returns the appropriate analysis JSON file name based on the provided tray type.
 *
 * @param {TrayType} trayType - The type of tray for which the analysis JSON file name is to be determined.
 * @returns {string} The name of the analysis JSON file corresponding to the specified tray type.
 */
export const getAnalysisJSONFileName = (trayType: TrayType): string => {
  switch (trayType?.toLowerCase()) {
    case 'stryker middle face':
      return 'Stryker_1.7_Mid_Face_top'
    case 'stryker upper face':
      return 'Stryker_1.2_Upper_Face'
    case 'zimmer curved rods':
      return 'Zimmer_curved_rods'
    case 'zimmer biomet vitality polyaxial screw caddy':
      return 'Zimmer_pedicle_screws'
    case 'zimmer standard closure tops':
      return 'Zimmer_standard_closure_tops'
    case 'zimmer adjustable transverse connector':
      return 'Zimmer_transverse_connectors'
    case '2.0 mini monster':
      return '2.0_Mini_Monster_SC'
    case '2.5 mini monster':
      return '2.5_Mini_Monster_SC'
    case '3.0 mini monster':
      return '3.0_Mini_Monster_SC'
    case 'headless compression screw rack':
      return 'Headless_Compression_Screw_Rack'
    case 'quickfix cannulated screw system':
      return 'QuickFix_Cannulated_Screw_System'
    case 'mini frag tray rack 4 top (plates)':
      return 'MFTR4TP'
    case 'mini frag tray rack 2 top (plates)':
      return 'MFTR2TRP'
    case 'mini frag tray rack 4 main (plates)':
      return 'MFTR4MP'
    case 'maxan anterior cervical plate system 1 level plates caddy':
      return 'MAACPS1LPC'
    case 'maxan anterior cervical plate system 2 level plates caddy':
      return 'MAACPS2LPC'
    case 'maxan anterior cervical plate system 3 level plates caddy':
      return 'MAACPS3LPC'
    case 'maxan anterior cervical plate system screw caddy':
      return 'MAACPSSC'
    case 'zimmer extra space test':
      return 'Zimmer_Extra_Space_Test'
    case 'alif trial set':
      return 'Alif_Trial_Set'
    case 'hedron ia locking screws':
      return 'Hedron_IA_Locking_Screws'
    case '24x30mm spacers':
      return '24x30mm_Spacers'
    case '26x34mm spacers':
      return '26x34mm_Spacers'
    case '29x39mm spacers':
      return '29x39mm_Spacers'
    case 'lumbar anchor set':
      return 'Lumbar_Anchor_Set'
    case 'stryker 2.0 mp plates upper tray':
      return 'Stryker_2.0MP_Upper_Plates'
    case 'stryker 2.0 mp plates lower tray':
      return 'Stryker_2.0MP_Lower_Plates'
    case 'kls martin 1.5mm lindorf orthognathic module subtray 1':
      return 'KLS_Martin_1.5mm_Lindorf_Orthognathic_Module_Subtray_1'
    case 'kls martin 1.5mm lindorf orthognathic module subtray 2':
      return 'KLS_Martin_1.5mm_Lindorf_Orthognathic_Module_Subtray_2'
    case 'kls martin 1.5mm micro module regular trauma pcoms':
      return 'KLS_Martin_1.5mm_Micro_Module_Regular_Trauma_PCOMS'
    case 'kls martin 2.0 micro module regular trauma pcoms':
      return 'KLS_Martin_2.0_Micro_Module_Regular_Trauma_PCOMS'
    case 'globus xtend cervical plate set':
      return 'Globus_Xtend_Cervical_Plate_Set'
    case 'globus xtend screw set':
      return 'Globus_Xtend_Screw_Set'
    default:
      return 'Stryker_2.0MP'
  }
}
